module.exports = __webpack_public_path__ + "static/media/traditional-print.ec66e6d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/traditional-print.svg
// module id = 1533
// module chunks = 0